import { useWindowSize } from '@vueuse/core'

type UseViewport = {
  width: Ref<number>
  height: Ref<number>
  isMobile: ComputedRef<boolean>
  isUntilDesktop: ComputedRef<boolean>
}

export default function (): UseViewport {
  const { width, height } = useWindowSize()
  const isMobile = computed(() => {
    return import.meta.server || width.value < 768
  })

  const isUntilDesktop = computed(() => {
    return import.meta.server || width.value < 1024
  })

  return { isMobile, isUntilDesktop, width, height }
}
